import { useTripTags } from "../admin/dictionaries/useTripTags";

export const useTripTagsByCategory = () => {
  const { tags, isLoading } = useTripTags();
  const tripTagsByCategory = tags.reduce(
    (acc, tag) => {
      if (!acc[tag.category]) {
        acc[tag.category] = [];
      }
      acc[tag.category].push(tag.name);
      return acc;
    },
    {} as Record<string, string[]>,
  );
  return { tripTagsByCategory, isLoading };
};
